
import { useState } from 'react';
import '../App.scss';
import { Button } from '@mui/base/Button';
import { useNavigate } from 'react-router-dom';

function ThankYou() {
 
  const navigate = useNavigate();
  
   const handleBackToProjects = () => {
    navigate('/projects');
  };

  return (
    <div className="main pb-4 d-flex flex-column align-items-center mb-4">
        <h1 className="mb-6">All done for now!</h1>
        <h4 className="mb-6">Thanks for using Our Journey.</h4>
        <p>You will hear back from us shortly.</p>
         <div className="mb-3">
            <Button className="styled-button" onClick={handleBackToProjects} id="btn-back-to-projects">
              View projects
            </Button>
        </div>
      </div>
  );
}

export default ThankYou;